import { useTranslation } from 'react-i18next'
import { useMediaQuery, useTheme } from '@mui/material'

import { Settings } from './settings'
import { FormTitle, Loader } from 'src/components'
import { useAccount, useMenuItems } from 'src/hooks'

import { AccountIcon } from '../account-icon'
import { ETranslationNs } from 'src/types'

export const AccountSupport = () => {
  const [t] = useTranslation(ETranslationNs.Navbar)
  const { data: account, isLoading } = useAccount()
  const { handleChooseMenuItem, menuItems } = useMenuItems([
    {
      title: t('account-support-header-title.v'),
      isActive: true,
      tab: 'support',
    },
  ])
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

  if (isLoading) {
    return <Loader />
  }

  return (
    <>
      {!isTablet ? (
        <FormTitle
          menuItems={menuItems}
          handleChooseMenuItem={handleChooseMenuItem}
          title={account?.account_holder ?? ''}
          imageComponent={<AccountIcon />}
        />
      ) : (
        <AccountIcon />
      )}
      {/* <div className={classes.tabWrapper}> */}
      <Settings />
      {/* </div> */}
    </>
  )
}
